var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserMinus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-plus",
    clipPath: "url(#clip0_7065_471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.917467 10.2507C1.55822 9.60997 2.42726 9.25 3.33341 9.25H8.00008C8.90624 9.25 9.77528 9.60997 10.416 10.2507C11.0568 10.8915 11.4167 11.7605 11.4167 12.6667V14C11.4167 14.4142 11.081 14.75 10.6667 14.75C10.2525 14.75 9.91675 14.4142 9.91675 14V12.6667C9.91675 12.1583 9.71481 11.6708 9.35537 11.3114C8.99592 10.9519 8.50841 10.75 8.00008 10.75H3.33341C2.82508 10.75 2.33757 10.9519 1.97813 11.3114C1.61868 11.6708 1.41675 12.1583 1.41675 12.6667V14C1.41675 14.4142 1.08096 14.75 0.666748 14.75C0.252534 14.75 -0.083252 14.4142 -0.083252 14V12.6667C-0.083252 11.7605 0.276717 10.8915 0.917467 10.2507Z",
    fill: "#A793F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66667 2.75C4.60812 2.75 3.75 3.60812 3.75 4.66667C3.75 5.72521 4.60812 6.58333 5.66667 6.58333C6.72521 6.58333 7.58333 5.72521 7.58333 4.66667C7.58333 3.60812 6.72521 2.75 5.66667 2.75ZM2.25 4.66667C2.25 2.77969 3.77969 1.25 5.66667 1.25C7.55364 1.25 9.08333 2.77969 9.08333 4.66667C9.08333 6.55364 7.55364 8.08333 5.66667 8.08333C3.77969 8.08333 2.25 6.55364 2.25 4.66667Z",
    fill: "#A793F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5833 7.33334C10.5833 6.91913 10.919 6.58334 11.3333 6.58334H15.3333C15.7475 6.58334 16.0833 6.91913 16.0833 7.33334C16.0833 7.74756 15.7475 8.08334 15.3333 8.08334H11.3333C10.919 8.08334 10.5833 7.74756 10.5833 7.33334Z",
    fill: "#A793F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7065_471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMinus);
export default __webpack_public_path__ + "static/media/user-minus.b716754e4116a52b7faa45cb259972a8.svg";
export { ForwardRef as ReactComponent };